<template>
	<div class="personal-index">
		<div class="head">
			<img src="../../assets/images/defaultHead.png" alt="" v-if="!userInfo">
			<img :src="userInfo.avatar" alt="" v-else>
			<div v-if="!userInfo" @click="goLogin">
				<p>未登录</p>
				<span>点击登陆/注册</span>
			</div>
			<div v-else>
				<p>{{userInfo.nickname}}</p>
				<span>{{userInfo.mobile}}</span>
			</div>
		</div>
		<div class="hr-7" style="background:#f0f0f0"></div>
		<div class="content">
			<div class="item" @click="skipPage(0)">
				<div>
					<img src="../../assets/images/Personal/index_guanzhu.png" alt="">
					<span>我的关注</span>					
				</div>
				<van-icon name="arrow"/>
			</div>
			<div class="item"  @click="skipPage(1)">
				<div>
					<van-icon name="like" />
					<span>我的收藏</span>					
				</div>
				<van-icon name="arrow" />
			</div>
			<div class="item" @click="skipPage(2)">
				<div>
					<van-icon name="manager" />
					<span>个人信息</span>					
				</div>
				<van-icon name="arrow" />
			</div>
			<!-- <div class="item">
				<div>
					<van-icon name="setting" />
					<span>设置</span>					
				</div>
				<van-icon name="arrow" />
			</div> -->
		</div>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
	import {PersoanalUserInfo} from "../../config/interface.js"
	import Tabbar from "../../components/Tabbar";
	export default{
		components:{
			Tabbar
		},
		data(){
			return{
				userInfo:'',  //用户信息
				index:3,    //tabbar中的index值
				isFirstEnter:false,    //是否第一次进入该页面
			}
		},
		beforeRouteEnter(to,from,next){
			if(from.name=='PersonalInfo'||from.name=='PersonalAttention'||from.name=='PersonalCollect'){
				to.meta.isBack=true;     //设为true说明你是返回到这个页面,而不是直接跳转到这个页面
			}
			next();
		},
		mounted(){
			this.isFirstEnter = true;
		},
		activated(){
			this.index=3;
			if(!this.$route.meta.isBack || this.isFirstEnter){
				this.getUserInfo();
			}
			this.$route.meta.isBack = false //请求完后进行初始化
            this.isFirstEnter = false;//请求完后进行初始化
			
		},
		methods:{
			//获取用户信息
			getUserInfo(){
				const url=PersoanalUserInfo;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.userInfo=data;
						 localStorage.setItem('userInfo',JSON.stringify(data));
           				 this.$store.dispatch('storageUserInfo',data);						
					}
				})
			},
			//去登录
			goLogin(){
				let url=window.location.href;
				this.$router.push({
					path:'/user/login',
					query:{
						url:url
					}
				})	
			},
			//点击跳转
			skipPage(type){
				if(this.userInfo){
					switch(type){
						case 0:
						this.$router.push({
							path:'/personal/attention',
						});
						break;
						case 1:
						this.$router.push({
							path:'/personal/collect',
						});
						break;
						case 2:
						this.$router.push({
							path:'/personal/info',
						});
						break;										
					}
				}else{
					let url=window.location.href;
					this.$router.push({
						path:'/user/login',
						query:{
							url:url
						}
					})					
				}
			}
		}
	}
</script>
<style lang="scss">
	.personal-index{
		width:100%;
		height:100%;
		background:#f8f8f8;
		.head{
			padding:0 15px;
			@include flex(row);
			/*justify-content:center;*/
			align-items:center;
			/*height:170px;*/
			height:120px;
			img{
				width:80px;
				height:80px;
				border-radius:50%;
				margin-right:15px;
			}
			div{
				p{
					font-size:16px;
					font-weight:700;
					margin-bottom:10px;
				}
				span{
					font-size:13px;
				}
			}
		}
		.content{
			padding:0px 12px;
			.item{
				@include flex(row);
				justify-content:space-between;
				align-items:center;
				border-bottom: 1px solid #D3D3D3;
				height:54px;
				line-height:54px;
				div{
					img{
						vertical-align:middle;
						height:22px;
					}
					i{
						vertical-align:middle;
						font-size:22px;
						color:#F85158;
					}
					span{
						font-size: 14px;
						color: #666666;
						letter-spacing: 0.49px;
						margin-left:17px;
					}
				}
				i{
					color:#cacaca;
				}

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/personal/Index.vue